import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import sliderS01 from '../assets/static/Katarina_home_10.jpg'
import sliderS02 from '../assets/static/Katarina_home_11.jpg'
import sliderS03 from '../assets/static/Katarina_home_12.jpg'
import sliderS04 from '../assets/static/Katarina_home_13.jpg'

export default new Vuex.Store({
  state: {
    // General
    showNav: true,
    titleLoading: false,
    months: [
        { name: "Jan", fullNameEng: "January", fullNameGer: "Januar", fullNameHr: "Siječanj", num: 1, numZero: "01", days: 31, weeks: [] },
        { name: "Feb", fullNameEng: "February", fullNameGer: "Februar", fullNameHr: "Veljača", num: 2, numZero: "02", days: 29, weeks: [] },
        { name: "Mar", fullNameEng: "March", fullNameGer: "März", fullNameHr: "Ožujak", num: 3, numZero: "03", days: 31, weeks: [] },
        { name: "Apr", fullNameEng: "April", fullNameGer: "April", fullNameHr: "Travanj", num: 4, numZero: "04", days: 30, weeks: [] },
        { name: "May", fullNameEng: "May", fullNameGer: "Mai", fullNameHr: "Svibanj", num: 5, numZero: "05", days: 31, weeks: [] },
        { name: "Jun", fullNameEng: "June", fullNameGer: "Juni", fullNameHr: "Lipanj", num: 6, numZero: "06", days: 30, weeks: [] },
        { name: "Jul", fullNameEng: "July", fullNameGer: "Juli", fullNameHr: "Srpanj", num: 7, numZero: "07", days: 31, weeks: [] },
        { name: "Aug", fullNameEng: "August", fullNameGer: "August", fullNameHr: "Kolovoz", num: 8, numZero: "08", days: 31, weeks: [] },
        { name: "Sep", fullNameEng: "September", fullNameGer: "September", fullNameHr: "Rujan", num: 9, numZero: "09", days: 30, weeks: [] },
        { name: "Oct", fullNameEng: "October", fullNameGer: "Oktober", fullNameHr: "Listopad", num: 10, numZero: "10", days: 31, weeks: [] },
        { name: "Nov", fullNameEng: "November", fullNameGer: "November", fullNameHr: "Studeni", num: 11, numZero: "11", days: 30, weeks: [] },
        { name: "Dec", fullNameEng: "December", fullNameGer: "Dezember", fullNameHr: "Prosinac", num: 12, numZero: "12", days: 31, weeks: [] }
    ],
    gallery: [
      /* OUTSIDE */
      {id: 1, src: () => import('../assets/images/gallery/katarina_outside_1.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 2, src: () => import('../assets/images/gallery/katarina_outside_2.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 3, src: () => import('../assets/images/gallery/katarina_outside_3.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 4, src: () => import('../assets/images/gallery/katarina_outside_4.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 5, src: () => import('../assets/images/gallery/katarina_outside_5.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 6, src: () => import('../assets/images/gallery/katarina_outside_6.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 7, src: () => import('../assets/images/gallery/katarina_outside_7.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 8, src: () => import('../assets/images/gallery/katarina_outside_8.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 9, src: () => import('../assets/images/gallery/katarina_outside_9.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 10, src: () => import('../assets/images/gallery/katarina_outside_10.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 11, src: () => import('../assets/images/gallery/katarina_outside_11.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 12, src: () => import('../assets/images/gallery/katarina_outside_12.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 13, src: () => import('../assets/images/gallery/katarina_outside_13.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 14, src: () => import('../assets/images/gallery/katarina_outside_14.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 15, src: () => import('../assets/images/gallery/katarina_outside_15.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 16, src: () => import('../assets/images/gallery/katarina_outside_16.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 17, src: () => import('../assets/images/gallery/katarina_outside_17.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 18, src: () => import('../assets/images/gallery/katarina_outside_18.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 19, src: () => import('../assets/images/gallery/katarina_outside_19.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 20, src: () => import('../assets/images/gallery/katarina_outside_20.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 21, src: () => import('../assets/images/gallery/katarina_outside_21.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 22, src: () => import('../assets/images/gallery/katarina_outside_22.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 23, src: () => import('../assets/images/gallery/katarina_outside_23.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},
      {id: 24, src: () => import('../assets/images/gallery/katarina_outside_24.jpg'), alt: 'Katarina di Maladel', block: 7, class: 'width'},

      /* AMENITIES */
      {id: 25, src: () => import('../assets/images/gallery/katarina_amenities_1.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 26, src: () => import('../assets/images/gallery/katarina_amenities_2.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 27, src: () => import('../assets/images/gallery/katarina_amenities_3.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 28, src: () => import('../assets/images/gallery/katarina_amenities_4.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 29, src: () => import('../assets/images/gallery/katarina_amenities_5.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 30, src: () => import('../assets/images/gallery/katarina_amenities_6.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 31, src: () => import('../assets/images/gallery/katarina_amenities_7.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 32, src: () => import('../assets/images/gallery/katarina_amenities_8.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 33, src: () => import('../assets/images/gallery/katarina_amenities_9.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 34, src: () => import('../assets/images/gallery/katarina_amenities_10.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 35, src: () => import('../assets/images/gallery/katarina_amenities_11.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 36, src: () => import('../assets/images/gallery/katarina_amenities_12.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},
      {id: 37, src: () => import('../assets/images/gallery/katarina_amenities_13.jpg'), alt: 'Katarina di Maladel', block: 6, class: 'width'},

      /* BATHROOMS */
      {id: 38, src: () => import('../assets/images/gallery/katarina_bathrooms_1.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 39, src: () => import('../assets/images/gallery/katarina_bathrooms_2.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 40, src: () => import('../assets/images/gallery/katarina_bathrooms_3.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 41, src: () => import('../assets/images/gallery/katarina_bathrooms_4.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 42, src: () => import('../assets/images/gallery/katarina_bathrooms_5.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 43, src: () => import('../assets/images/gallery/katarina_bathrooms_6.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 44, src: () => import('../assets/images/gallery/katarina_bathrooms_7.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 45, src: () => import('../assets/images/gallery/katarina_bathrooms_8.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},
      {id: 46, src: () => import('../assets/images/gallery/katarina_bathrooms_9.jpg'), alt: 'Katarina di Maladel', block: 5, class: 'width'},

      /* BEDROOMS */
      {id: 47, src: () => import('../assets/images/gallery/katarina_bedrooms_1.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 48, src: () => import('../assets/images/gallery/katarina_bedrooms_2.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 49, src: () => import('../assets/images/gallery/katarina_bedrooms_3.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 50, src: () => import('../assets/images/gallery/katarina_bedrooms_4.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 51, src: () => import('../assets/images/gallery/katarina_bedrooms_5.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 52, src: () => import('../assets/images/gallery/katarina_bedrooms_6.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 53, src: () => import('../assets/images/gallery/katarina_bedrooms_7.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 54, src: () => import('../assets/images/gallery/katarina_bedrooms_8.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 55, src: () => import('../assets/images/gallery/katarina_bedrooms_9.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 56, src: () => import('../assets/images/gallery/katarina_bedrooms_10.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 57, src: () => import('../assets/images/gallery/katarina_bedrooms_11.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 58, src: () => import('../assets/images/gallery/katarina_bedrooms_12.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 59, src: () => import('../assets/images/gallery/katarina_bedrooms_13.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 60, src: () => import('../assets/images/gallery/katarina_bedrooms_14.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 61, src: () => import('../assets/images/gallery/katarina_bedrooms_15.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 62, src: () => import('../assets/images/gallery/katarina_bedrooms_16.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 63, src: () => import('../assets/images/gallery/katarina_bedrooms_17.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 64, src: () => import('../assets/images/gallery/katarina_bedrooms_18.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 65, src: () => import('../assets/images/gallery/katarina_bedrooms_19.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 66, src: () => import('../assets/images/gallery/katarina_bedrooms_20.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 67, src: () => import('../assets/images/gallery/katarina_bedrooms_21.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 68, src: () => import('../assets/images/gallery/katarina_bedrooms_22.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 69, src: () => import('../assets/images/gallery/katarina_bedrooms_23.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 70, src: () => import('../assets/images/gallery/katarina_bedrooms_24.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 71, src: () => import('../assets/images/gallery/katarina_bedrooms_25.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 72, src: () => import('../assets/images/gallery/katarina_bedrooms_26.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 73, src: () => import('../assets/images/gallery/katarina_bedrooms_27.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 74, src: () => import('../assets/images/gallery/katarina_bedrooms_28.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},
      {id: 75, src: () => import('../assets/images/gallery/katarina_bedrooms_29.jpg'), alt: 'Katarina di Maladel', block: 4, class: 'width'},

      /* LIVING ROOM */
      {id: 76, src: () => import('../assets/images/gallery/katarina_living_room_1.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 77, src: () => import('../assets/images/gallery/katarina_living_room_2.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 78, src: () => import('../assets/images/gallery/katarina_living_room_3.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 79, src: () => import('../assets/images/gallery/katarina_living_room_4.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 80, src: () => import('../assets/images/gallery/katarina_living_room_5.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 81, src: () => import('../assets/images/gallery/katarina_living_room_6.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 82, src: () => import('../assets/images/gallery/katarina_living_room_7.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 83, src: () => import('../assets/images/gallery/katarina_living_room_8.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 84, src: () => import('../assets/images/gallery/katarina_living_room_9.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 85, src: () => import('../assets/images/gallery/katarina_living_room_10.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},
      {id: 86, src: () => import('../assets/images/gallery/katarina_living_room_11.jpg'), alt: 'Katarina di Maladel', block: 3, class: 'width'},

      /* KITCHEN */
      {id: 87, src: () => import('../assets/images/gallery/katarina_kitchen_1.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 84, src: () => import('../assets/images/gallery/katarina_kitchen_2.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'}, 
      {id: 85, src: () => import('../assets/images/gallery/katarina_kitchen_3.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'}, 
      {id: 88, src: () => import('../assets/images/gallery/katarina_kitchen_4.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 89, src: () => import('../assets/images/gallery/katarina_kitchen_5.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 90, src: () => import('../assets/images/gallery/katarina_kitchen_6.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 91, src: () => import('../assets/images/gallery/katarina_kitchen_7.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 92, src: () => import('../assets/images/gallery/katarina_kitchen_8.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 93, src: () => import('../assets/images/gallery/katarina_kitchen_9.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 94, src: () => import('../assets/images/gallery/katarina_kitchen_10.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 95, src: () => import('../assets/images/gallery/katarina_kitchen_11.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},
      {id: 96, src: () => import('../assets/images/gallery/katarina_kitchen_12.jpg'), alt: 'Katarina di Maladel', block: 2, class: 'width'},

      /* EVENTS */
      {id: 97, src: () => import('../assets/images/gallery/katarina_events_1.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 98, src: () => import('../assets/images/gallery/katarina_events_2.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 99, src: () => import('../assets/images/gallery/katarina_events_3.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 100, src: () => import('../assets/images/gallery/katarina_events_4.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 101, src: () => import('../assets/images/gallery/katarina_events_5.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 102, src: () => import('../assets/images/gallery/katarina_events_6.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 103, src: () => import('../assets/images/gallery/katarina_events_7.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 104, src: () => import('../assets/images/gallery/katarina_events_8.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 105, src: () => import('../assets/images/gallery/katarina_events_9.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 106, src: () => import('../assets/images/gallery/katarina_events_10.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 107, src: () => import('../assets/images/gallery/katarina_events_11.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 108, src: () => import('../assets/images/gallery/katarina_events_12.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 109, src: () => import('../assets/images/gallery/katarina_events_13.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 110, src: () => import('../assets/images/gallery/katarina_events_14.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 111, src: () => import('../assets/images/gallery/katarina_events_15.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 112, src: () => import('../assets/images/gallery/katarina_events_16.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 113, src: () => import('../assets/images/gallery/katarina_events_17.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 114, src: () => import('../assets/images/gallery/katarina_events_18.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 115, src: () => import('../assets/images/gallery/katarina_events_19.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 116, src: () => import('../assets/images/gallery/katarina_events_20.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},
      {id: 117, src: () => import('../assets/images/gallery/katarina_events_21.jpg'), alt: 'Katarina di Maladel', block: 8, class: 'width'},

      /* ALL */
      {id: 118, src: () => import('../assets/images/gallery/katarina_outside_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 119, src: () => import('../assets/images/gallery/katarina_outside_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 120, src: () => import('../assets/images/gallery/katarina_outside_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 121, src: () => import('../assets/images/gallery/katarina_outside_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 122, src: () => import('../assets/images/gallery/katarina_outside_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 123, src: () => import('../assets/images/gallery/katarina_outside_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 124, src: () => import('../assets/images/gallery/katarina_outside_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 125, src: () => import('../assets/images/gallery/katarina_outside_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 126, src: () => import('../assets/images/gallery/katarina_outside_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 127, src: () => import('../assets/images/gallery/katarina_outside_10.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 128, src: () => import('../assets/images/gallery/katarina_outside_11.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 129, src: () => import('../assets/images/gallery/katarina_outside_12.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 130, src: () => import('../assets/images/gallery/katarina_outside_13.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 131, src: () => import('../assets/images/gallery/katarina_outside_14.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 132, src: () => import('../assets/images/gallery/katarina_outside_15.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 133, src: () => import('../assets/images/gallery/katarina_outside_16.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 134, src: () => import('../assets/images/gallery/katarina_outside_17.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 135, src: () => import('../assets/images/gallery/katarina_outside_18.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 136, src: () => import('../assets/images/gallery/katarina_outside_19.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 137, src: () => import('../assets/images/gallery/katarina_outside_20.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 138, src: () => import('../assets/images/gallery/katarina_outside_21.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 139, src: () => import('../assets/images/gallery/katarina_outside_22.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 140, src: () => import('../assets/images/gallery/katarina_outside_23.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 141, src: () => import('../assets/images/gallery/katarina_outside_24.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 142, src: () => import('../assets/images/gallery/katarina_amenities_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 143, src: () => import('../assets/images/gallery/katarina_amenities_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 144, src: () => import('../assets/images/gallery/katarina_amenities_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 145, src: () => import('../assets/images/gallery/katarina_amenities_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 146, src: () => import('../assets/images/gallery/katarina_amenities_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 147, src: () => import('../assets/images/gallery/katarina_amenities_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 148, src: () => import('../assets/images/gallery/katarina_amenities_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 149, src: () => import('../assets/images/gallery/katarina_amenities_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 150, src: () => import('../assets/images/gallery/katarina_amenities_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 151, src: () => import('../assets/images/gallery/katarina_amenities_10.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 152, src: () => import('../assets/images/gallery/katarina_amenities_11.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 153, src: () => import('../assets/images/gallery/katarina_amenities_12.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 154, src: () => import('../assets/images/gallery/katarina_amenities_13.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 155, src: () => import('../assets/images/gallery/katarina_bathrooms_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 156, src: () => import('../assets/images/gallery/katarina_bathrooms_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 157, src: () => import('../assets/images/gallery/katarina_bathrooms_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 158, src: () => import('../assets/images/gallery/katarina_bathrooms_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 159, src: () => import('../assets/images/gallery/katarina_bathrooms_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 160, src: () => import('../assets/images/gallery/katarina_bathrooms_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 161, src: () => import('../assets/images/gallery/katarina_bathrooms_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 162, src: () => import('../assets/images/gallery/katarina_bathrooms_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 163, src: () => import('../assets/images/gallery/katarina_bathrooms_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 164, src: () => import('../assets/images/gallery/katarina_bedrooms_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 165, src: () => import('../assets/images/gallery/katarina_bedrooms_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 166, src: () => import('../assets/images/gallery/katarina_bedrooms_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 167, src: () => import('../assets/images/gallery/katarina_bedrooms_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 168, src: () => import('../assets/images/gallery/katarina_bedrooms_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 169, src: () => import('../assets/images/gallery/katarina_bedrooms_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 170, src: () => import('../assets/images/gallery/katarina_bedrooms_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 171, src: () => import('../assets/images/gallery/katarina_bedrooms_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 172, src: () => import('../assets/images/gallery/katarina_bedrooms_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 173, src: () => import('../assets/images/gallery/katarina_bedrooms_10.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 174, src: () => import('../assets/images/gallery/katarina_bedrooms_11.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 175, src: () => import('../assets/images/gallery/katarina_bedrooms_12.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 176, src: () => import('../assets/images/gallery/katarina_bedrooms_13.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 177, src: () => import('../assets/images/gallery/katarina_bedrooms_14.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 178, src: () => import('../assets/images/gallery/katarina_bedrooms_15.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 179, src: () => import('../assets/images/gallery/katarina_bedrooms_16.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 180, src: () => import('../assets/images/gallery/katarina_bedrooms_17.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 181, src: () => import('../assets/images/gallery/katarina_bedrooms_18.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 182, src: () => import('../assets/images/gallery/katarina_bedrooms_19.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 183, src: () => import('../assets/images/gallery/katarina_bedrooms_20.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 184, src: () => import('../assets/images/gallery/katarina_bedrooms_21.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 185, src: () => import('../assets/images/gallery/katarina_bedrooms_22.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 186, src: () => import('../assets/images/gallery/katarina_bedrooms_23.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 187, src: () => import('../assets/images/gallery/katarina_bedrooms_24.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 188, src: () => import('../assets/images/gallery/katarina_bedrooms_25.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 189, src: () => import('../assets/images/gallery/katarina_bedrooms_26.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 190, src: () => import('../assets/images/gallery/katarina_bedrooms_27.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 191, src: () => import('../assets/images/gallery/katarina_bedrooms_28.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 192, src: () => import('../assets/images/gallery/katarina_bedrooms_29.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 193, src: () => import('../assets/images/gallery/katarina_living_room_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 194, src: () => import('../assets/images/gallery/katarina_living_room_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 195, src: () => import('../assets/images/gallery/katarina_living_room_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 196, src: () => import('../assets/images/gallery/katarina_living_room_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 197, src: () => import('../assets/images/gallery/katarina_living_room_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 198, src: () => import('../assets/images/gallery/katarina_living_room_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 199, src: () => import('../assets/images/gallery/katarina_living_room_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 200, src: () => import('../assets/images/gallery/katarina_living_room_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 201, src: () => import('../assets/images/gallery/katarina_living_room_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 202, src: () => import('../assets/images/gallery/katarina_living_room_10.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 203, src: () => import('../assets/images/gallery/katarina_living_room_11.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 204, src: () => import('../assets/images/gallery/katarina_kitchen_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 205, src: () => import('../assets/images/gallery/katarina_kitchen_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'}, 
      {id: 206, src: () => import('../assets/images/gallery/katarina_kitchen_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'}, 
      {id: 207, src: () => import('../assets/images/gallery/katarina_kitchen_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 208, src: () => import('../assets/images/gallery/katarina_kitchen_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 209, src: () => import('../assets/images/gallery/katarina_kitchen_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 210, src: () => import('../assets/images/gallery/katarina_kitchen_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 211, src: () => import('../assets/images/gallery/katarina_kitchen_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 212, src: () => import('../assets/images/gallery/katarina_kitchen_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 213, src: () => import('../assets/images/gallery/katarina_kitchen_10.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 214, src: () => import('../assets/images/gallery/katarina_kitchen_11.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 215, src: () => import('../assets/images/gallery/katarina_kitchen_12.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 216, src: () => import('../assets/images/gallery/katarina_events_1.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 217, src: () => import('../assets/images/gallery/katarina_events_2.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 218, src: () => import('../assets/images/gallery/katarina_events_3.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 219, src: () => import('../assets/images/gallery/katarina_events_4.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 220, src: () => import('../assets/images/gallery/katarina_events_5.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 221, src: () => import('../assets/images/gallery/katarina_events_6.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 222, src: () => import('../assets/images/gallery/katarina_events_7.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 223, src: () => import('../assets/images/gallery/katarina_events_8.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 224, src: () => import('../assets/images/gallery/katarina_events_9.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 225, src: () => import('../assets/images/gallery/katarina_events_10.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 226, src: () => import('../assets/images/gallery/katarina_events_11.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 227, src: () => import('../assets/images/gallery/katarina_events_12.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 228, src: () => import('../assets/images/gallery/katarina_events_13.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 229, src: () => import('../assets/images/gallery/katarina_events_14.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 230, src: () => import('../assets/images/gallery/katarina_events_15.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 231, src: () => import('../assets/images/gallery/katarina_events_16.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 232, src: () => import('../assets/images/gallery/katarina_events_17.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 233, src: () => import('../assets/images/gallery/katarina_events_18.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 234, src: () => import('../assets/images/gallery/katarina_events_19.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 235, src: () => import('../assets/images/gallery/katarina_events_20.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
      {id: 236, src: () => import('../assets/images/gallery/katarina_events_21.jpg'), alt: 'Katarina di Maladel', block: 1, class: 'width'},
    ],
    galleryIndex: 0,
    galleryFilter: 0,
    // Booking
    calendarData: [],
    bookingData: {},
    currentYear: '',
    // Inquiry
    inquiryData: {},
    // Language
    lang: 'eng',
    eng: {
      key: 1,
      nav: ['Home', 'Stancija', 'Services', 'Experience' , 'Gallery', 'Lang', 'BOOK'],
      home: {
        title: 'MEMORABLE FRAGMENTS OF LIFE',
        videoQuote: '“What sticks to memory, often, are those odd little fragments that have no beginning and no end.”',
        tailoredTitle: 'Tailored for you',
        tailoredSection: {
            t1: 'Sun',
            p1: '+2,400 sunny hours a year',
            t2: 'Spa',
            p2: 'Heated pool, 2 saunas, solarium and jacuzzi',
            t3: 'Wine',
            p3: 'Private vineyard & domestic wine',
        },
        diningRoomVideo: 'Time spent together',
        billiardVideo: 'Making new memories',
        doubleVideoTitle: 'New dimension of luxury...',
        twoVideoSection: {
            t1: 'Privacy and nature',
            p1: '2,5 hectares estate with more than 1000 plants, only for you',
            t2: 'Designed to enjoy',
            p2: 'Kitchen, living room and 4 bedroom with bathrooms, up to 8 people',
        },
        lampVideo: {
            desc: '...without a compromise',
            p1: 'Organize events & weddings',
            p2: 'Concierge services',
            p3: 'Spa & Wellness',
            p4: 'Heated swimming pool',
            p5: 'Garden & vineyard',
        },
        ytVideoTitle: 'Take a look what you can expect on Stancija Katarina di Maladel!',
        bookTitle: 'Luxury vacation at your doorstep',
        bookNow: 'BOOK NOW →',
        acc: 'Stancija',
        ft: 'Services',
        p1: 'A peaceful oasis of relaxation and intimacy is the place we have envisaged as the ideal setting for this story. Providing the perfect escape from busy daily routine and set in breathtaking scenery, Stancija Katarina di Maladel can also brag with its services so you can completely relax and enjoy while we take care of all your needs.',
        galleryCards: [
          {id: 1, alt: 'Katarina di Maladel', src: 'Katarina_home_04.jpg', room: 'Living Room'},
          {id: 2, alt: 'Katarina di Maladel', src: 'Katarina_home_05.jpg', room: 'Bathroom'},
          {id: 3, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Kitchen'},
          {id: 4, alt: 'Katarina di Maladel', src: 'Katarina_home_07.jpg', room: 'Bedroom'},
          {id: 5, alt: 'Katarina di Maladel', src: 'Katarina_home_08.jpg', room: 'Entertainment'},
          {id: 6, alt: 'Katarina di Maladel', src: 'Katarina_home_09.jpg', room: 'Outside'},
          {id: 7, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Events'}
        ],
        clickForMore: 'Click for more',
        discoverMore: 'Discover more',
        t1: 'Luxury and beauty without compromise.',
        checkAva: 'Check availability',
        t2: 'Even easier to find us',
        visitGal: 'VISIT GALLERY NOW'
      },
      stancija: {
        chairVideo: 'Fragments of vacation',
        villaIcons: {
          i1: '4 bedrooms',
          i2: '8 people',
          i3: '5 bathrooms',
          i4: '2 saunas', 
          i5: 'Heated pool',
          i6: 'Billiard/poker',
        },
        insidePoolVideo: 'Awaken your senses',
        vineyardVideo: 'Discover new emotions',
        stancijaFrameText: {
          t1: 'Privacy and nature',
          p1: 'Cascading gardens, spreading vineyards and sea in distance',
          t2: 'Merged with nature',
          p2: 'Superior atmosphere made of wood, stone and glass details',
        },
        jacuzziVideo: 'Pamper yourself',
        bookTitle: 'Luxury vacation at your doorstep',
        bookNow: 'BOOK NOW →',
      },
      services: {
        servicesMain: {
          t1: 'TAILORED JUST',
          t2: 'FOR YOU',
        },
        brideText: {
          t1: 'Your dream day, our venue',
          p1: 'Embark on a journey of timeless love and unparalleled beauty',
        },
        weddingTitle: 'Perfect wedding venue in Istria',
        servicesParallax1: 'Many events, one place',
        imageText1: {
          t1:'Concierge services',
          p1:'Professional for reservations, recommendations, and arranging activities in the local area.',
          t2:'Private Chef/Catering',
          p2:'Professional private chef or catering services allow you to enjoy gourmet meals tailored to your preferences.',
          t3:'Gourmet cooking classes',
          p3:'Arrange for private cooking classes with renowned chefs where you can learn to prepare local Istrian dishes.',
        },
        imageText2: {
          t1:'Wine cellar',
          p1:'Selection of premium Croatian wines in a dedicated cellar for you to enjoy at Stancija Katarina.',
          t2:'In-Villa mixologist / bartender',
          p2:'Have a professional mixologist create custom cocktails and drinks for the best celebration of your vacation.',
          t3:'Grocery shopping',
          p3:'Pre-stocking the villa with groceries based on your preferences and dietary requirements.',
        },
        imageText3: {
          t1:'Private tours in Istria',
          p1:'Based your preferences we can arrange you a private guided tours to explore magical Istrian sightseeings.',
          t2:'In-Villa photographer',
          p2:'Book a professional photographer who will capture your special vacation memories with your loved ones.',
          t3:'Personal security',
          p3:'24/7 discreet security personnel for those who value privacy and safety during vacation.',
        },
        imageText4: {
          t1:'Private yacht or boat charters',
          p1:'Day trips or sunset cruises by renting a private yacht or boats with skipers will make your vacation even more magical.',
          t2:'VIP transfers',
          p2:'Transfers all around Istria with VIP car transfers and professional drivers with maximum safety and privacy.',
          t3:'Housekeeping',
          p3:'Regular cleaning and housekeeping services ensuring that the villa is well-maintained throughout your staying.',
        },
        imageText5: {
          t1:'Spa and Wellness services',
          p1:'In-villa spa treatments, massages and wellness, provides you with relaxation and rejuvenation.',
          t2:'Pet pampering',
          p2:'Pet grooming for those who travel with their furry companions.',
          t3:'Childcare services',
          p3:'Offering babysitting or childcare services for some alone time or with your partner.',
        },
        bookTitle: 'Luxury vacation at your doorstep',
        bookNow: 'BOOK NOW →',
      },
      experience: {
        experienceMainTitle: 'CHERISH. CAPTURE. RELIEVE.',
        imageText6: {
          p1:'Located next to Umag, Stancija Katarina di Maladed gives you a wonderful chance to explore the captivating attractions that Istria has to offer.',
          p2:'From nature and historical sites to adrenalin or gastronomy experience.',
          p3:'Enjoy like never before!',
        },
        imageText7: {
          t1:'Pula',
          p1:'Pula is famous for its well-preserved Roman amphitheater. Explore the historic city center and enjoy the vibrant atmosphere.',
          t2:'Brijuni Islands',
          p2:'Take a boat trip to the Brijuni Islands, a national park known for its natural beauty, diverse flora and fauna and clear water.',
          t3:'Rovinj',
          p3:'This picturesque coastal town is characterized by its narrow streets, colorful buildings. Enjoy panoramic views, explore art galleries and delicious seafood.',
        },
        imageText8: {
          t1:'Dinopark Funtana',
          p1:'This theme park is designed around the concept of dinosaurs and offers interactive exhibitions, a playground, and a small water park.',
          t2:'Aquapark Istralandia',
          p2:'Experience the most entertaining water in Istria at the Aquapark Istralandia. Explore the thrilling attractions, slides and pools for unique fun.',
          t3:'Truffle hunting',
          p3:'Engage in a truffle hunting experience with your family, where you can learn about the local truffle-hunting tradition and even participate in a guided hunt.',
        },
        imageText9: {
          t1:'Hum',
          p1:'Visit Hum, the charming Istrian village renowned as the world’s smallest town, enjoy in its rich history and captivating ambiance.',
          t2:'Agricultural and Cultural Tours',
          p2:'Consider joining guided tours that allow you to explore the region’s agricultural heritage, including olive oil and wine production.',
          t3:'Cycling and hiking trails',
          p3:'Istria offers numerous cycling and hiking trails through picturesque landscapes, charming villages and historical sites.',
        },
        imageText10: {
          t1:'Motovun',
          p1:'Town built on a charming hilltop known for its medieval architecture and stunning views of the surrounding countryside.',
          t2:'Lim Fjord',
          p2:'A scenic natural inlet famous for its seafood farms and pristine waters. Perfect place for bout tours and enjoy fresh seafood.',
          t3:'Cope Kamenjak',
          p3:'A rugged natural peninsula with beautiful beaches and clear blue waters. It’s a great spot to enjoy the unspoiled nature.',
        },
        imageText11: {
          t1:'Traditional Cuisine',
          p1:'Don’t miss the opportunity to indulge in Istrian cuisine. Try dishes like Istrian prosciutto, truffle-based specialties, seafood, and pastas.',
          t2:'Aquaparks',
          p2:'There are several aquaparks in Istria, such as Aquacolors Poreč and Istralandia, offering water slides, pools, and entertainment for everyone.',
          t3:'Beaches',
          p3:'Enjoy the Adriatic coastline with its beautiful beaches. Some recommended family-friendly beaches like Laguna Beach and Aurora.',
        },
        bookTitle: 'Luxury vacation at your doorstep',
        bookNow: 'BOOK NOW →',
      },
      gallery: {
        filters: ['All', 'Kitchen', 'Living Room', 'Bedrooms', 'Bathrooms', 'Amenities', 'Outside', 'Events'],
        nav: ['Home', 'Stancija', 'Services', 'Experience' , 'Gallery', 'Lang', 'BOOK'],
      },
      book: {
        inquiryTitle: 'Send us an inquiry',
        fullName: 'Full name:',
        emailAddress: 'Email address:',
        phoneNumber: 'Phone number:',
        inquirySubject: 'Inquiry Subject',
        services: [
          { value: null, text: 'Select service', disable: true },
          { value: 1, text: 'Vacation reservation' },
          { value: 2, text: 'Event organization' }
        ],
        persons: [
            { value: null, text: 'Number of people', disable: true },
            { value: 1, text: '1 person' },
            { value: 2, text: '2 persons' },
            { value: 3, text: '3 persons' },
            { value: 4, text: '4 persons' },
            { value: 5, text: '5 persons' },
            { value: 6, text: '6 persons' },
            { value: 7, text: '7 persons' },
            { value: 8, text: '8 persons' }
        ],
        details: 'Enter details...',
        btn: 'SEND'
      },
      privacyPolicy: {
        title: 'Privacy Policy',
        t1: 'Notice of submitting written complaints of service users',
        p1: 'In accordance with the provisions of Art. 6. St.1 item 3. Of the Law on Provision of Tourism Services NN no. 130/17 a consumer’s written complaint may be submitted via:',
        li1: 'email:',
        email: 'info@katarinadimaladel.com',
        p2: 'The received complaint of the service, user will be notiﬁed in writing without delay, the receipt of the complaint will be conﬁrmed, and the objection will be answered in writing within 15 days from the day of receipt of the complaint.'
      },
      footer: {
        contact: 'CONTACT US',
        brochure: 'Privacy Policy',
        desc: 'Explore our second villa; Stancija Čabrunići and book with special discount',
      }
    },
    hrv: {
      key: 2,
      nav: ['Početna', 'Stancija', 'Usluge', 'Iskustvo' , 'Galerija', 'Lang', 'BOOK'],
      home: {
        title: 'NEZABORAVNI FRAGMENTI  ŽIVOTA',
        videoQuote: '“Ono što često ostaje u sjećanju su oni čudni mali fragmenti koji nemaju ni početka ni kraja.”',
        tailoredTitle: 'Prilagođeno vama',
        tailoredSection: {
            t1: 'Sunce',
            p1: '+2,400 sunčanih sati godišnje',
            t2: 'Spa',
            p2: 'Grijani bazen, 2 saune, solarij i jacuzzi',
            t3: 'Vino',
            p3: 'Privatni vinograd i domaće vino',
        },
        diningRoomVideo: 'Vrijeme provedeno zajedno',
        billiardVideo: 'Stvaranje novih uspomena',
        doubleVideoTitle: 'Nova dimenzija luksuza...',
        twoVideoSection: {
            t1: 'Privatnost i priroda',
            p1: 'Posjed od 2,5 hektara s više od 1000 biljaka, samo za vas',
            t2: 'Dizajnirano za uživanje',
            p2: 'Kuhinja, dnevni boravak i 4 spavaće sobe s kupaonicama, do 8 osoba',
        },
        lampVideo: {
            desc: '...bez kompromisa',
            p1: 'Organizacija događaja i vjenčanja',
            p2: 'Usluge recepcije',
            p3: 'Spa i wellness',
            p4: 'Grijani bazen',
            p5: 'Vrt i vinograd',
        },
        ytVideoTitle: 'Pogledajte što možete očekivati na Stanciji Katarina di Maladel!',
        bookTitle: 'Luksuzni odmor na dohvat ruke',
        bookNow: 'REZERVIRAJTE ODMAH →',
        acc: 'Stancija',
        ft: 'Services',
        p1: 'A peaceful oasis of relaxation and intimacy is the place we have envisaged as the ideal setting for this story. Providing the perfect escape from busy daily routine and set in breathtaking scenery, Stancija Katarina di Maladel can also brag with its services so you can completely relax and enjoy while we take care of all your needs.',
        galleryCards: [
          {id: 1, alt: 'Katarina di Maladel', src: 'Katarina_home_04.jpg', room: 'Living Room'},
          {id: 2, alt: 'Katarina di Maladel', src: 'Katarina_home_05.jpg', room: 'Bathroom'},
          {id: 3, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Kitchen'},
          {id: 4, alt: 'Katarina di Maladel', src: 'Katarina_home_07.jpg', room: 'Bedroom'},
          {id: 5, alt: 'Katarina di Maladel', src: 'Katarina_home_08.jpg', room: 'Entertainment'},
          {id: 6, alt: 'Katarina di Maladel', src: 'Katarina_home_09.jpg', room: 'Outside'},
          {id: 7, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Events'}
        ],
        clickForMore: 'Click for more',
        discoverMore: 'Discover more',
        t1: 'Luxury and beauty without compromise.',
        checkAva: 'Check availability',
        t2: 'Even easier to find us',
        visitGal: 'VISIT GALLERY NOW'
      },
      stancija: {
        chairVideo: 'Fragmenti odmora',
        villaIcons: {
          i1: '4 spavaće sobe',
          i2: '8 osoba',
          i3: '5 kupaonica',
          i4: '2 saune', 
          i5: 'Grijani bazen',
          i6: 'Biljar/poker',
        },
        insidePoolVideo: 'Probudite svoja osjetila',
        vineyardVideo: 'Otkrijte nove emocije',
        stancijaFrameText: {
          t1: 'Privatnost i priroda',
          p1: 'Kaskadni vrtovi, prostrani vinogradi i more u daljini',
          t2: 'Spojeni s prirodom',
          p2: 'Superiorna atmosfera od drveta, kamena i staklenih detalja',
        },
        jacuzziVideo: 'Pazite na sebe',
        bookTitle: 'Luksuzni odmor na dohvat ruke',
        bookNow: 'REZERVIRAJTE ODMAH →',
      },
      services: {
        servicesMain: {
          t1: 'PRILAGOĐENO SAMO',
          t2: 'ZA VAS',
        },
        brideText: {
          t1: 'Vaša dnevna avantura iz snova, naša destinacija.',
          p1: 'Krenite na putovanje beskrajne ljubavi i nevjerojatne ljepote',
        },
        weddingTitle: 'Savršeno mjesto za vjenčanje u Istri',
        servicesParallax1: 'Mnogo događaja, jedno mjesto',
        imageText1: {
          t1:'Concierge usluge',
          p1:'Profesionalno za rezervacije, preporuke i organiziranje aktivnosti u lokalnom području.',
          t2:'Privatni kuhar/usluge cateringa',
          p2:'Profesionalni privatni kuhar ili usluge cateringa omogućuju vam uživanje u gurmanskim jelima prilagođenim vašim željama.',
          t3:'Gurmanski tečajevi kuhanja',
          p3:'Organizirajte privatne tečajeve kuhanja s poznatim kuharima gdje možete naučiti pripremati lokalna istarska jela.',
        },
        imageText2: {
          t1:'Vinski podrum',
          p1:'Izbor vrhunskih hrvatskih vina u posebnom podrumu za vas da uživate na Stanciji Katarina.',
          t2:'Miksolog/barmen u vili',
          p2:'Imajte profesionalnog mikologa koji će kreirati posebne koktele i pića za najbolje proslave vašeg odmora.',
          t3:'Kupovina namirnica',
          p3:'Predobavljanje namirnica u vili prema vašim preferencijama i prehrambenim zahtjevima.',
        },
        imageText3: {
          t1:'Privatni obilasci u Istri',
          p1:'Prema vašim preferencijama možemo organizirati privatne vođene ture kako biste istražili čarobne istarske znamenitosti.',
          t2:'Fotograf u vili',
          p2:'Rezervirajte profesionalnog fotografa koji će zabilježiti vaše posebne uspomene na odmoru s voljenima.',
          t3:'Osobna sigurnost',
          p3:'24/7 diskretno osiguranje za one koji cijene privatnost i sigurnost tijekom odmora.',
        },
        imageText4: {
          t1:'Privatni najam jahti ili brodova',
          p1:'Izleti ili vožnje zalaskom sunca najamom privatnih jahti ili brodova s skiperima učinit će vaš odmor još magičnijim.',
          t2:'VIP prijevozi',
          p2:'Prijevozi diljem Istre s VIP prijevozima automobilima i profesionalnim vozačima s maksimalnom sigurnošću i privatnošću.',
          t3:'Posluga u kući',
          p3:'Redovito čišćenje i usluge održavanja osiguravajući da je vila dobro održavana tijekom vašeg boravka.',
        },
        imageText5: {
          t1:'Usluge spa i wellnessa',
          p1:'Spa tretmani, masaže i wellness usluge u vili pružaju vam opuštanje i obnavljanje.',
          t2:'Njega kućnih ljubimaca',
          p2:'Zbrinjavanje kućnih ljubimaca za one koji putuju sa svojim krznenim prijateljima.',
          t3:'Usluge čuvanja djece',
          p3:'Nudimo usluge čuvanja djece ili skrbi o djeci za vrijeme kada želite provesti vrijeme samo za sebe ili s partnerom.',
        },
        bookTitle: 'Luksuzni odmor na dohvat ruke',
        bookNow: 'REZERVIRAJTE ODMAH →',
      },
      experience: {
        experienceMainTitle: 'UŽIVAJTE. ZABILJEŽITE. OSLOBODITE.',
        imageText6: {
          p1:'Nalazi se pored Umaga, Stancija Katarina di Maladed pruža vam prekrasnu priliku da istražite fascinantne atrakcije koje Istra nudi.',
          p2:'Od prirodnih i povijesnih lokaliteta do adrenalinskih ili gastronomskih iskustava.',
          p3:'Uživajte kao nikada prije!',
        },
        imageText7: {
          t1:'Pula',
          p1:'Pula je poznata po svom dobro očuvanom rimskom amfiteatru. Istražite povijesni centar grada i uživajte u živahnoj atmosferi.',
          t2:'Brijuni',
          p2:'Uzmite brodski izlet do Brijuna, nacionalnog parka poznatog po svojoj prirodnoj ljepoti, raznolikoj flori i fauni te čistoj vodi.',
          t3:'Rovinj',
          p3:'Ovaj slikoviti primorski grad karakteriziraju uske ulice i šarene zgrade. Uživajte u panoramskim pogledima, istražite galerije umjetnosti i uživajte u ukusnim plodovima mora.',
        },
        imageText8: {
          t1:'Dinopark Funtana',
          p1:'Ovaj tematski park osmišljen je oko koncepta dinosaura i nudi interaktivne izložbe, dječje igralište i mali vodeni park.',
          t2:'Aquapark Istralandia',
          p2:'Doživite najzabavniju vodu u Istri u Aquaparku Istralandia. Istražite uzbudljive atrakcije, tobogane i bazene za jedinstvenu zabavu.',
          t3:'Lov na tartufe',
          p3:'Uključite se u iskustvo lova na tartufe sa svojom obitelji, gdje možete naučiti o lokalnoj tradiciji lova na tartufe i čak sudjelovati u vođenom lovu.',
        },
        imageText9: {
          t1:'Hum',
          p1:'Posjetite Hum, šarmantno istarsko selo poznato kao najmanji grad na svijetu, uživajte u bogatoj povijesti i privlačnoj atmosferi.',
          t2:'Poljoprivredne i kulturne ture',
          p2:'Razmislite o pridruživanju vođenim turama koje vam omogućuju istraživanje poljoprivredne baštine regije, uključujući proizvodnju maslinovog ulja i vina.',
          t3:'Staze za biciklizam i planinarenje',
          p3:'Istra nudi brojne staze za biciklizam i planinarenje kroz slikovite krajolike, šarmantna sela i povijesne lokalitete.',
        },
        imageText10: {
          t1:'Motovun',
          p1:'Grad smješten na šarmantnom brdu poznat po svojoj srednjovjekovnoj arhitekturi i impresivnim pogledima na okolni krajolik.',
          t2:'Limski zaljev',
          p2:'Scenski prirodni zaljev poznat po uzgoju morskih plodova i čistim vodama. Savršeno mjesto za brodski izlet i uživanje u svježim morskim plodovima.',
          t3:'Park prirode Rt Kamenjak',
          p3:'Divlja prirodna poluotok s prekrasnim plažama i kristalno plavim vodama. To je odlično mjesto za uživanje u netaknutoj prirodi.',
        },
        imageText11: {
          t1:'Tradicionalna kuhinja',
          p1:'Ne propustite priliku da uživate u istarskoj kuhinji. Probajte jela poput istarskog pršuta, specijaliteta s tartufima, plodova mora i tjestenine.',
          t2:'Aquaparkovi',
          p2:'U Istri se nalazi nekoliko aquaparkova, poput Aquacolors Poreča i Istralandije, koji nude tobogane, bazene i zabavu za sve uzraste.',
          t3:'Plaže',
          p3:'Uživajte na jadranskoj obali s prekrasnim plažama. Neki preporučeni obiteljski prijateljski plažni odredi su plaža Laguna i Aurora.',
        },
        bookTitle: 'Luksuzni odmor na dohvat ruke',
        bookNow: 'REZERVIRAJTE ODMAH →',
      },
      gallery: {
          filters: ['Sve slike', 'Kuhinja', 'Dnevna soba', 'Spavaće sobe', 'Kupaonice', 'Pogodnosti', 'Vanjski prostor', 'Događaji'],
          nav: ['Početna', 'Stancija', 'Usluge', 'Iskustvo', 'Galerija', 'LANG', 'BOOK'],
        },
      book: {
        inquiryTitle: 'Pošaljite nam upit',
        fullName: 'Ime i prezime:',
        emailAddress: 'Adresa e-pošte:',
        phoneNumber: 'Broj telefona:',
        inquirySubject: 'Predmet upita',
        services: [
          { value: null, text: 'Odaberite uslugu', disable: true },
          { value: 1, text: 'Rezervacija odmora' },
          { value: 2, text: 'Organizacija događaja' }
        ],
        persons: [
            { value: null, text: 'Broj osoba', disable: true },
            { value: 1, text: '1 osoba' },
            { value: 2, text: '2 osobe' },
            { value: 3, text: '3 osobe' },
            { value: 4, text: '4 osobe' },
            { value: 5, text: '5 osoba' },
            { value: 6, text: '6 osoba' },
            { value: 7, text: '7 osoba' },
            { value: 8, text: '8 osoba' }
        ],
        details: 'Unesite detalje...',
        btn: 'POŠALJI'
      },
      privacyPolicy: {
        title: 'Privacy Policy',
        t1: 'Notice of submitting written complaints of service users',
        p1: 'In accordance with the provisions of Art. 6. St.1 item 3. Of the Law on Provision of Tourism Services NN no. 130/17 a consumer’s written complaint may be submitted via:',
        li1: 'email:',
        email: 'info@katarinadimaladel.com',
        p2: 'The received complaint of the service, user will be notiﬁed in writing without delay, the receipt of the complaint will be conﬁrmed, and the objection will be answered in writing within 15 days from the day of receipt of the complaint.'
      },
      footer: {
        link1: 'Contact Us',
        link2: 'Privacy Policy'
      }
    },
    de: {
      key: 3,
      nav: ['Home', 'Stancija', 'Serviceleistungen', 'Erfahrung', 'Galerie', 'Lang', 'BOOK'],
      home: {
        title: 'DENKWÜRDIG FRAGMENTE DES LEBENS',
        videoQuote: '“Was oft im Gedächtnis bleibt, sind diese seltsamen kleinen Fragmente, die keinen Anfang und kein Ende haben.”',
        tailoredTitle: 'Auf Sie zugeschnitten',
        tailoredSection: {
            t1: 'Sonne',
            p1: '+2.400 sonnige Stunden pro Jahr',
            t2: 'Spa',
            p2: 'Beheizter Pool, 2 Saunen, Solarium und Whirlpool',
            t3: 'Wein',
            p3: 'Privater Weinberg & Hauswein',
        },
        diningRoomVideo: 'Zeit zusammen verbracht',
        billiardVideo: 'Neue Erinnerungen schaffen',
        doubleVideoTitle: 'Eine neue Dimension des Luxus...',
        twoVideoSection: {
            t1: 'Privatsphäre und Natur',
            p1: '2,5 Hektar Anwesen mit mehr als 1000 Pflanzen, nur für Sie',
            t2: 'Entworfen zum Genießen',
            p2: 'Küche, Wohnzimmer und 4 Schlafzimmer mit Badezimmern, für bis zu 8 Personen',
        },
        lampVideo: {
            desc: '...ohne Kompromisse',
            p1: 'Veranstaltungsplanung',
            p2: 'Concierge-Dienste',
            p3: 'Spa & Wellness',
            p4: 'Beheizter Pool',
            p5: 'Garten & Weinberg',
        },
        ytVideoTitle: 'Schauen Sie, was Sie auf Stancija Katarina di Maladel erwartet!',
        bookTitle: 'Luxusurlaub vor Ihrer Haustür',
        bookNow: 'JETZT BUCHEN →',
        acc: 'Stancija',
        ft: 'Services',
        p1: 'A peaceful oasis of relaxation and intimacy is the place we have envisaged as the ideal setting for this story. Providing the perfect escape from busy daily routine and set in breathtaking scenery, Stancija Katarina di Maladel can also brag with its services so you can completely relax and enjoy while we take care of all your needs.',
        galleryCards: [
          {id: 1, alt: 'Katarina di Maladel', src: 'Katarina_home_04.jpg', room: 'Living Room'},
          {id: 2, alt: 'Katarina di Maladel', src: 'Katarina_home_05.jpg', room: 'Bathroom'},
          {id: 3, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Kitchen'},
          {id: 4, alt: 'Katarina di Maladel', src: 'Katarina_home_07.jpg', room: 'Bedroom'},
          {id: 5, alt: 'Katarina di Maladel', src: 'Katarina_home_08.jpg', room: 'Entertainment'},
          {id: 6, alt: 'Katarina di Maladel', src: 'Katarina_home_09.jpg', room: 'Outside'},
          {id: 7, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Events'}
        ],
        clickForMore: 'Click for more',
        discoverMore: 'Discover more',
        t1: 'Luxury and beauty without compromise.',
        checkAva: 'Check availability',
        t2: 'Even easier to find us',
        visitGal: 'VISIT GALLERY NOW'
      },
      stancija: {
        chairVideo: 'Ferienfragmente',
        villaIcons: {
          i1: '4 Schlafzimmer',
          i2: '8 Personen',
          i3: '5 Badezimmer',
          i4: '2 Saunen', 
          i5: 'Beheizter Pool',
          i6: 'Billard/Poker',
        },
        insidePoolVideo: 'Erwecken Sie Ihre Sinne',
        vineyardVideo: 'Entdecken Sie neue Emotionen',
        stancijaFrameText: {
          t1: 'Privatsphäre und Natur',
          p1: 'Terrassierte Gärten, ausgedehnte Weinberge und das Meer in der Ferne',
          t2: 'Vereint mit der Natur',
          p2: 'Superiore Atmosphäre aus Holz, Stein und Glasdetails',
        },
        jacuzziVideo: 'Gönnen Sie sich etwas',
        bookTitle: 'Luxusurlaub vor Ihrer Haustür',
        bookNow: 'JETZT BUCHEN →',
      },
      services: {
        servicesMain: {
          t1: 'MAßGESCHNEIDERT',
          t2: 'FÜR SIE',
        },
        brideText: {
          t1: 'Ihr Traumtag, unsere Location',
          p1: 'Begib dich auf eine Reise der zeitlosen Liebe und unvergleichlichen Schönheit',
        },
        weddingTitle: 'Perfekte Hochzeitslocation in Istrien',
        servicesParallax1: 'Viele Veranstaltungen, ein Ort',
        imageText1: {
          t1:'Concierge-Dienstleistungen',
          p1:'Professionell für Reservierungen, Empfehlungen und die Organisation von Aktivitäten in der lokalen Umgebung.',
          t2:'Privatkoch/Catering-Service',
          p2:'Professioneller Privatkoch oder Catering-Service ermöglicht es Ihnen, Gourmet-Mahlzeiten nach Ihren Vorlieben zu genießen.',
          t3:'Kochkurse der Gourmet-Küche',
          p3:'Vereinbaren Sie private Kochkurse mit renommierten Köchen, bei denen Sie lernen, lokale istrische Gerichte zuzubereiten.',
        },
        imageText2: {
          t1:'Weinkeller',
          p1:'Auswahl an Premium-kroatischen Weinen in einem speziellen Keller, damit Sie auf Stancija Katarina genießen können.',
          t2:'In-Villa-Mixologe/Barkeeper',
          p2:'Lassen Sie einen professionellen Mixologen individuelle Cocktails und Getränke für die beste Feier Ihres Urlaubs kreieren.',
          t3:'Lebensmitteleinkauf',
          p3:'Vorbestellung der Villa mit Lebensmitteln nach Ihren Vorlieben und Ernährungsbedürfnissen.',
        },
        imageText3: {
          t1:'Private Touren in Istrien',
          p1:'Basierend auf Ihren Vorlieben können wir für Sie private geführte Touren arrangieren, um die magischen Sehenswürdigkeiten Istriens zu erkunden.',
          t2:'In-Villa-Fotograf',
          p2:'Buchen Sie einen professionellen Fotografen, der Ihre besonderen Urlaubserinnerungen mit Ihren Lieben festhält.',
          t3:'Persönliche Sicherheit',
          p3:'Diskretes Sicherheitspersonal rund um die Uhr für diejenigen, die Privatsphäre und Sicherheit im Urlaub schätzen.',
        },
        imageText4: {
          t1:'Privat-Yacht oder Bootscharter',
          p1:'Tagesausflüge oder Sonnenuntergangskreuzfahrten durch die Anmietung einer privaten Yacht oder Boote mit Skippern machen Ihren Urlaub noch magischer.',
          t2:'VIP transfers',
          p2:'Transfers in ganz Istrien mit VIP-Autotransfers und professionellen Fahrern mit maximaler Sicherheit und Privatsphäre.',
          t3:'Haushaltshilfe',
          p3:'Regelmäßige Reinigungs- und Haushaltsdienste gewährleisten, dass die Villa während Ihres Aufenthalts gut gepflegt ist.',
        },
        imageText5: {
          t1:'Spa und Wellnessdienstleistungen',
          p1:'Spa Behandlungen, Massagen und Wellnessdienste in der Villa sorgen für Entspannung und Erholung.',
          t2:'Tierverwöhnung',
          p2:'Tierpflege für diejenigen, die mit ihren pelzigen Begleitern reisen.',
          t3:'Kinderbetreuung',
          p3:'Anbieten von Babysitting- oder Kinderbetreuungsdiensten für etwas Zeit alleine oder mit Ihrem Partner.',
        },
        bookTitle: 'Luxusurlaub vor Ihrer Haustür',
        bookNow: 'JETZT BUCHEN →',
      },
      experience: {
        experienceMainTitle: 'GENIEßEN. ERFASSEN. ENTSPANNEN.',
        imageText6: {
          p1:'In der Nähe von Umag gelegen, bietet Ihnen die Stancija Katarina di Maladed eine wunderbare Gelegenheit, die faszinierenden Attraktionen zu erkunden, die Istrien zu bieten hat.',
          p2:'Von Natur- und historischen Sehenswürdigkeiten bis hin zu Adrenalin- oder Gastronomieerlebnissen.',
          p3:'Genießen Sie wie nie zuvor!',
        },
        imageText7: {
          t1:'Pula',
          p1:'Pula ist berühmt für ihr gut erhaltenes römisches Amphitheater. Entdecken Sie das historische Stadtzentrum und genießen Sie die lebendige Atmosphäre.',
          t2:'Brijuni-Inseln',
          p2:'Unternehmen Sie einen Bootsausflug zu den Brijuni-Inseln, einem Nationalpark, der für seine natürliche Schönheit, vielfältige Flora und Fauna und klares Wasser bekannt ist.',
          t3:'Rovinj',
          p3:'Diese malerische Küstenstadt zeichnet sich durch ihre engen Gassen und bunten Gebäude aus. Genießen Sie Panoramablicke, erkunden Sie Kunstgalerien und köstliche Meeresfrüchte.',
        },
        imageText8: {
          t1:'Dinopark Funtana',
          p1:'Dieser Themenpark ist rund um das Konzept der Dinosaurier gestaltet und bietet interaktive Ausstellungen, einen Spielplatz und einen kleinen Wasserpark.',
          t2:'Aquapark Istralandia',
          p2:'Erleben Sie das unterhaltsamste Wasser in Istrien im Aquapark Istralandia. Entdecken Sie die aufregenden Attraktionen, Rutschen und Pools für einzigartigen Spaß.',
          t3:'Trüffelsuche',
          p3:'Erleben Sie ein Trüffelsuchabenteuer mit Ihrer Familie, bei dem Sie die lokale Tradition der Trüffelsuche kennenlernen und sogar an einer geführten Jagd teilnehmen können.',
        },
        imageText9: {
          t1:'Hum',
          p1:'Besuchen Sie Hum, das charmante istrische Dorf, das als kleinste Stadt der Welt bekannt ist, und genießen Sie seine reiche Geschichte und faszinierende Atmosphäre.',
          t2:'Agrar- und Kulturführungen',
          p2:'Erwägen Sie, an geführten Touren teilzunehmen, die es Ihnen ermöglichen, das agrarische Erbe der Region zu erkunden, einschließlich der Produktion von Olivenöl und Wein.',
          t3:'Rad- und Wanderwege',
          p3:'Istrien bietet zahlreiche Rad- und Wanderwege durch malerische Landschaften, charmante Dörfer und historische Stätten.',
        },
        imageText10: {
          t1:'Motovun',
          p1:'Stadt auf einem bezaubernden Hügel bekannt für ihre mittelalterliche Architektur und atemberaubende Aussicht auf die umliegende Landschaft.',
          t2:'Limski Kanal',
          p2:'Ein malerischer natürlicher Einschnitt, berühmt für seine Meeresfrüchtefarmen und klaren Gewässer. Perfekter Ort für Bootstouren und frischen Fischgenuss.',
          t3:'Kap Kamenjak',
          p3:'Eine raue natürliche Halbinsel mit wunderschönen Stränden und klarem blauem Wasser. Es ist ein großartiger Ort, um die unberührte Natur zu genießen.',
        },
        imageText11: {
          t1:'Traditionelle Küche',
          p1:'Verpassen Sie nicht die Gelegenheit, die istrische Küche zu genießen. Probieren Sie Gerichte wie istrischen Schinken, auf Trüffeln basierende Spezialitäten, Meeresfrüchte und Pasta.',
          t2:'Aquaparks',
          p2:'In Istrien gibt es mehrere Aquaparks wie Aquacolors Poreč und Istralandia, die Wasserrutschen, Pools und Unterhaltung für jedermann bieten.',
          t3:'Strände',
          p3:'Genießen Sie die Adriaküste mit ihren wunderschönen Stränden. Einige empfohlene familienfreundliche Strände sind Laguna Beacha und Aurora.',
        },
        bookTitle: 'Luxusurlaub vor Ihrer Haustür',
        bookNow: 'JETZT BUCHEN →',
      },
      gallery: {
        filters: ['Alle', 'Küche', 'Wohnzimmer', 'Schlafzimmer', 'Bad', 'Unterhaltung', 'Draußen', 'Events'],
        nav: ['Home', 'Stancija', 'Serviceleistungen', 'Erfahrung' , 'Galerie', 'Lang', 'BOOK'],
      },
      book: {
        inquiryTitle: 'Schicken Sie uns eine Anfrage',
        fullName: 'Vollständiger Name:',
        emailAddress: 'E-Mail-Adresse:',
        phoneNumber: 'Telefonnummer:',
        inquirySubject: 'Anfragethema',
        services: [
          { value: null, text: 'Service auswählen', disable: true },
          { value: 1, text: 'Urlaubsreservierung' },
          { value: 2, text: 'Veranstaltungsorganisation' }
        ],
        persons: [
          { value: null, text: 'Anzahl der Personen', disable: true },
          { value: 1, text: '1 Person' },
          { value: 2, text: '2 Personen' },
          { value: 3, text: '3 Personen' },
          { value: 4, text: '4 Personen' },
          { value: 5, text: '5 Personen' },
          { value: 6, text: '6 Personen' },
          { value: 7, text: '7 Personen' },
          { value: 8, text: '8 Personen' }
        ],
      
        details: 'Details eingeben...',
        btn: 'SENDEN'
    },
      privacyPolicy: {
        title: 'Privacy Policy',
        t1: 'Notice of submitting written complaints of service users',
        p1: 'In accordance with the provisions of Art. 6. St.1 item 3. Of the Law on Provision of Tourism Services NN no. 130/17 a consumer’s written complaint may be submitted via:',
        li1: 'email:',
        email: 'info@katarinadimaladel.com',
        p2: 'The received complaint of the service, user will be notiﬁed in writing without delay, the receipt of the complaint will be conﬁrmed, and the objection will be answered in writing within 15 days from the day of receipt of the complaint.'
      },
      footer: {
        link1: 'Contact Us',
        link2: 'Privacy Policy'
      }
    },
  },
  mutations: {
    setNavState (state, payload) {
      state.showNav = payload
    },
    setTitleLoading (state, payload) {
      state.titleLoading = payload
    },
    setCalendarData (state, payload) {
      let saved = false;
      if (state.calendarData.length > 0) {
        state.calendarData.forEach(function(item) {
          if (item.year === state.currentYear)  {
            item.dateList = payload.dateList;
            saved = true;
          }
        })
        if (!saved) state.calendarData.push(payload)
      } else {
        state.calendarData.push(payload)
      }
    },
    setBookingData (state, payload) {
      state.bookingData = payload
    },
    setCurrentYear (state, payload) {
      state.currentYear = payload
    },
    setInquiryData (state, payload) {
      state.inquiryData = payload
    },
    setGalleryIndex (state, payload) {
      state.galleryIndex = payload;
    },
    setImageSource (state, payload) {
      state.gallery[state.galleryIndex].src = payload;
    },
    setGalleryFilterNumber (state, payload) {
      state.galleryFilter = payload;
    },
    toggleLang (state, payload) {
      state.lang = payload
    }
  },
  getters: {
    getWebData: state => {
      if (state.lang === 'eng') return state.eng
      else if (state.lang === 'de') return state.de
      else  return state.hrv
    },
    getLang: state => {
      return state.lang
    },
    getNavState: state => {
      return state.showNav
    },
    getTitleLoadingState: state => {
      return state.titleLoading
    },
    getMonths: state => {
      return state.months
    },
    getCalendarData: state => {
      return state.calendarData.filter(item => item.year === state.currentYear)
    },
    getBookingData: state => {
      return state.bookingData
    },
    getInquiryData: state => {
      return state.inquiryData
    },
    getGalleryImage: state => {
      return state.gallery[state.galleryIndex]
    },
    getGalleryFilter: state => {
      return state.gallery.filter(g => g.block === state.galleryFilter)
    },
    getGalleryAll: state => {
      return state.gallery
    }
  },
  actions: {
    getIndexOfImage ({state}, img) {
      return state.gallery.findIndex(i => i.id === img.id);
    }
  },
  modules: {
  }
})
